module.exports = __webpack_public_path__ + "img/tab3.5f86be95.png";